import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackButtonClickedSpec,
  trackFeatureToggledSpec,
  trackFieldSelectedSpec,
  trackModalViewedSpec,
  trackPanelClosedSpec,
  trackPanelOpenedSpec,
  trackScreenViewedSpec,
  trackToggleUpdatedSpec,
  trackUiInteractionSpec,
  type ButtonClicked,
  type FeatureToggled,
  type FieldSelected,
  type ModalViewed,
  type PanelClosed,
  type PanelOpened,
  type ScreenViewed,
  type ToggleUpdated,
  type UIInteraction,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const uiEvents: SnowplowEventMap = {
  [TrackingEventName.UiInteraction]: (props) =>
    trackUiInteractionSpec(props as UIInteraction),

  [TrackingEventName.ButtonClicked]: (props) =>
    trackButtonClickedSpec(props as ButtonClicked),

  [TrackingEventName.ScreenViewed]: (props) =>
    trackScreenViewedSpec(props as ScreenViewed),

  [TrackingEventName.ModalViewed]: (props) => trackModalViewedSpec(props as ModalViewed),

  [TrackingEventName.FieldSelected]: (props) =>
    trackFieldSelectedSpec(props as FieldSelected),

  [TrackingEventName.PanelOpened]: (props) => trackPanelOpenedSpec(props as PanelOpened),

  [TrackingEventName.PanelClosed]: (props) => trackPanelClosedSpec(props as PanelClosed),

  [TrackingEventName.ToggleUpdated]: (props) =>
    trackToggleUpdatedSpec(props as ToggleUpdated),

  [TrackingEventName.FeatureToggled]: (props) =>
    trackFeatureToggledSpec(props as FeatureToggled),
};
